import { ApplicationContext } from '@upside/spa-shared-context';

import { globalHeaderAppName, paths } from 'shell/const';
import { getAppStatus, registerApplication, LifeCycles } from 'single-spa';

/**
 * List of paths where the app header should not be shown
 */
const PATHS_WITH_GLOBAL_HEADER = [`/${paths.ASSET_SETTLEMENT}`];

/**
 * Registers global header app if the local storage feature flag is set
 */
export const registerGlobalHeader = (context: ApplicationContext): void => {
  if (!getAppStatus(globalHeaderAppName)) {
    registerApplication({
      activeWhen: ({ pathname }) =>
        context.authentication.loggedIn &&
        PATHS_WITH_GLOBAL_HEADER.some((path) => pathname.startsWith(path)),
      app: () => System.import(globalHeaderAppName) as Promise<LifeCycles>,
      name: globalHeaderAppName,
      customProps: {
        context,
        domElementGetter: () =>
          document.querySelector('#global-header-container'),
      },
    });
  }
};
